import React from 'react';
import styled from '@emotion/styled';

import Center from '../common/Center';
import { Box } from '@mui/material';

const Footer = styled.div`
  background-color: ${(props) => props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)} ${(props) => props.theme.spacing(4)};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const handleClick = () => {
  window.open('https://www.getskimmer.com', '_blank');
};

const SidebarFooter: React.FC = ({ ...rest }) => {
  return (
    <Footer {...rest}>
      <Center py={1} pr={3}>
        <Box sx={{ cursor: 'pointer' }} p={0} m={0}>
          <img src="/static/img/powered-skimmer-2x.png" alt="Skimmer Logo" width={150} onClick={handleClick} />
        </Box>
      </Center>
    </Footer>
  );
};

export default SidebarFooter;
